import { render, staticRenderFns } from "./AdminChurnPanel.vue?vue&type=template&id=5c2ef693&scoped=true"
import script from "./AdminChurnPanel.vue?vue&type=script&lang=js"
export * from "./AdminChurnPanel.vue?vue&type=script&lang=js"
import style0 from "./AdminChurnPanel.vue?vue&type=style&index=0&id=5c2ef693&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2ef693",
  null
  
)

export default component.exports